<template>
  <v-navigation-drawer
    :value="value"
    right
    temporary
    fixed
    width="848"
    role="dialog"
    aria-modal="true"
    aria-labelledby="gg-drawer-import-title"
    class="gg-idrawer"
    @input="$emit('input', $event)"
  >
    <div class="gg-idrawer__header">
      <h2 id="gg-drawer-import-title" class="gg-idrawer__title">Importar templates e cenas</h2>
      <button type="button" class="gg-idrawer__close" aria-label="Fechar" @click="close">
        <v-icon size="24">mdi-close</v-icon>
      </button>
    </div>

    <div class="gg-idrawer__body" @scroll="onScroll">
      <GloboGraphicsTemplatePicker ref="picker" :selected.sync="selected" />
    </div>

    <div class="gg-idrawer__footer">
      <button type="button" class="gg-idrawer__submit" :disabled="!canImport" @click="doImport">
        {{ importing ? 'Importando…' : 'Importar' }}
      </button>
    </div>
  </v-navigation-drawer>
</template>

<script>
/**
 * Imports Vizrt templates into the production as cenas. The whole selection
 * goes in one request; the API reports per-template failures so a single bad
 * template cannot lose the rest.
 */
import { mapActions } from 'vuex'
import GloboGraphicsTemplatePicker from './GloboGraphicsTemplatePicker.vue'

import ggDrawerA11y from '@/mixins/ggDrawerA11y'

export default {
  mixins: [ggDrawerA11y],
  name: 'GloboGraphicsImportDrawer',
  components: { GloboGraphicsTemplatePicker },
  props: {
    value: { type: Boolean, default: false },
    codProducao: { type: [Number, String], default: null },
  },
  data() {
    return {
      selected: [],
      importing: false,
    }
  },
  computed: {
    canImport() {
      return !!(this.selected.length && this.codProducao && !this.importing)
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.selected = []
        this.$nextTick(() => this.$refs.picker?.reload())
      }
    },
  },
  methods: {
    ...mapActions({ saveVizrtCenasBulk: 'globographics/saveVizrtCenasBulk' }),
    close() {
      this.$emit('input', false)
    },
    onScroll(e) {
      this.$refs.picker?.maybeLoadMore(e.target)
    },
    async doImport() {
      if (!this.canImport) return
      this.importing = true
      try {
        const { created = [], failed = [] } = await this.saveVizrtCenasBulk({
          cod_producao: this.codProducao,
          templates: this.selected.map((t) => ({ templateId: t.id, dsc_nome_cena: t.title })),
        })

        if (failed.length) {
          this.$toast?.error?.(`${created.length} importado(s), ${failed.length} com erro.`)
        } else {
          this.$toast?.success?.(`${created.length} template(s) importado(s)`)
        }
        this.$emit('imported')
        // Leave the drawer open on a partial import so the operator can retry the
        // failures — but narrow the selection down to exactly those. Keeping the
        // whole selection meant a second click re-sent the ones that had already
        // succeeded, creating a duplicate cena for each. Match on `failed`, whose
        // templateId is the id we sent; `created` carries the normalized PDS id,
        // which does not always equal it.
        const failedIds = new Set(failed.map((f) => String(f.templateId)))
        this.selected = this.selected.filter((t) => failedIds.has(String(t.id)))
        if (!failed.length) {
          this.close()
        }
      } catch (e) {
        this.$toast?.error?.(e.response?.data?.error || 'Erro ao importar templates')
      } finally {
        this.importing = false
      }
    },
  },
}
</script>
